<div #tooltip class="tooltip hidden" *ngIf="interactivity">
  <div class="content">
    <p>
      <span class="name"></span>
      <span class="category"></span>
    </p>
    <p>
      <span class="value"></span>
      <small class="unit"></small>
    </p>
  </div>
  <button>{{ 'Click to go to map' | translate }}</button>
</div>
<div
  class="legend"
  *ngIf="
    colorScale &&
    (config.printMode ? categories.length !== 0 : categories.length > 1)
  "
>
  <div
    class="legend-item"
    [class.generic-tooltip]="interactivity"
    [class.top]="interactivity"
    [class.interactive]="interactivity"
    [attr.data-tooltip]="cat.category_name | translate"
    [class.selected]="selectedCategory === cat.category"
    *ngFor="let cat of categories; let index = index"
  >
    <div class="color" [style.background-color]="getColor(cat, index)"></div>
    <p
      class="name"
      (click)="
        selectedCategory !== cat.category
          ? selectCategory(cat.category)
          : selectCategory(null)
      "
    >
      {{ cat.category_name | translate }}
    </p>
    <button class="remove-btn" (click)="selectCategory(null)"></button>
  </div>
</div>
<svg [class.interactive]="interactivity" #svg></svg>
